import React from 'react'
import {formatTimeWithMeridiem} from '../../../utils/time'
import styled from 'styled-components'

export const renderHourNamed = (hour, isVertical, idx, truncateHeader) => {
  let hours = Math.floor(hour)
  let minutes = hour - hours === 0 ? 0 : 30
  let now = new Date()
  let hourDate = new Date(
    now.getFullYear(),
    now.getMonth() - 1,
    now.getDay(),
    hours,
    minutes,
    0
  )
  let {time, ampm} = formatTimeWithMeridiem({date: hourDate})

  // Remove the :00 from the time string if using am/pm
  if (ampm) {
    let timeItems = time.split(':')
    if (timeItems[1] === '00') {
      time = timeItems[0]
    }
  }

  return (
    <HourContainer isVertical={isVertical} key={idx} truncateHeader={truncateHeader}>
      <HourText>{time}</HourText>
      <TimeText>{ampm}</TimeText>
    </HourContainer>
  )
}

const HourText = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #000000;
`

const TimeText = styled(HourText)`
  padding-bottom: 6px;
  padding-left: 1px;
  font-size: 14px;
  font-weight: normal;
`

const HourContainer = styled.div`
  min-width: ${props => props.truncateHeader ? '59px' : '118px'};
  max-width: ${props => props.truncateHeader ? '59px' : '118px'};
  height: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: ${props => (props.isVertical ? 'none' : '1px solid #eff0f3')}; 
 
  
  padding-left: ${props => (props.isVertical ? '20px' : '0')};
  border-right: ${props => (props.isVertical ? '1px solid #eff0f3' : 'none')};
  text-align: ${props => (props.isVertical ? 'center' : 'default')};
`
